// extracted by mini-css-extract-plugin
module.exports = {"SICContainer":"styles_SICContainer__3K9mC","SICLabel":"styles_SICLabel__1mJtk","SICValue":"styles_SICValue__3OTj-","noSICValue":"styles_noSICValue__1_n54"};